const toNumber = (value, fallback = 0) => {
    const n = Number(value);
    return Number.isNaN(n) ? fallback : n;
};

export const normalizeProductFilters = (apiResponse, language = "el") => {
    const d = apiResponse?.data;
    const filters = d?.filters ?? {};

    const categories = Array.isArray(filters.categories)
        ? filters.categories.map((item) => ({
            id: String(item.id),
            name: language === "en"
                ? (item.nameEN ?? item.nameEL ?? "")
                : (item.nameEL ?? item.nameEN ?? ""),
            nameEL: item.nameEL ?? "",
            nameEN: item.nameEN ?? "",
            count: toNumber(item.count, 0),
        }))
        : [];

    const brands = Array.isArray(filters.brands)
        ? filters.brands.map((item) => ({
            id: String(item.id),
            name: language === "en"
                ? (item.nameEN ?? item.nameEL ?? "")
                : (item.nameEL ?? item.nameEN ?? ""),
            nameEL: item.nameEL ?? "",
            nameEN: item.nameEN ?? "",
            count: toNumber(item.count, 0),
        }))
        : [];

    const colors = Array.isArray(filters.colors)
        ? filters.colors.map((item) => ({
            id: String(item.id),
            name: language === "en"
                ? (item.nameEN ?? item.nameEL ?? "")
                : (item.nameEL ?? item.nameEN ?? ""),
            nameEL: item.nameEL ?? "",
            nameEN: item.nameEN ?? "",
            count: toNumber(item.count, 0),
            hex: item.hex ? (item.hex.startsWith("#") ? item.hex : `#${item.hex}`) : null,
        }))
        : [];

    return {
        categories,
        products: [],
        brands,
        colors,
        price: {
            min: toNumber(filters.price?.min, 0),
            max: toNumber(filters.price?.max, 0),
        },
        count: toNumber(d?.count, 0),
    };
};